import { LocalStorage } from 'libs/storage/LocalStorage';
const TOKEN_KEY = 'terminal.token';
const NAME_KEY = 'terminal.name';
const ACCOUNT_KEY = 'terminal.account';
/**
 * The device token a paired terminal presents on every request.
 *
 * It lives in local storage because the whole point is that the device is
 * paired once and never signs in again. It is not a session: it identifies
 * the venue, and every redemption still asks an operator for their PIN.
 *
 * @class TerminalToken
 * @since 1.0.0
 */
export class TerminalToken {
    /**
     * @method get
     * @since 1.0.0
     */
    static get() {
        try {
            return LocalStorage.get(TOKEN_KEY);
        }
        catch (_a) {
            // Private browsing, or storage disabled: the device simply reads as
            // unpaired and is sent back to the pairing screen.
            return null;
        }
    }
    /**
     * @method set
     * @since 1.0.0
     */
    static set(token, terminalName, accountName) {
        try {
            LocalStorage.set(TOKEN_KEY, token);
            LocalStorage.set(NAME_KEY, terminalName);
            LocalStorage.set(ACCOUNT_KEY, accountName);
        }
        catch (_a) {
            /* nothing useful to do; the next screen will say it is not paired */
        }
    }
    /**
     * @method clear
     * @since 1.0.0
     */
    static clear() {
        try {
            LocalStorage.set(TOKEN_KEY, null);
            LocalStorage.set(NAME_KEY, null);
            LocalStorage.set(ACCOUNT_KEY, null);
        }
        catch (_a) {
            /* see above */
        }
    }
    /**
     * @method describe
     * @since 1.0.0
     */
    static describe() {
        var _a, _b;
        try {
            return {
                terminalName: (_a = LocalStorage.get(NAME_KEY)) !== null && _a !== void 0 ? _a : '',
                accountName: (_b = LocalStorage.get(ACCOUNT_KEY)) !== null && _b !== void 0 ? _b : ''
            };
        }
        catch (_c) {
            return { terminalName: '', accountName: '' };
        }
    }
}
